module.exports = __webpack_public_path__ + "a38d93ed169079b9d8d26e5d5dce7628.MP3";